import { ThemeOptions } from '@mui/material';

import { capitalDesignTokens } from '../../capital_design_tokens';

export const MuiSlider: ThemeOptions['components']['MuiSlider'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(1.5, 0)
      // This cannot be applied until https://github.com/mui/material-ui/issues/29506 is fixed
      // '& .Mui-focusVisible': {
      //   outline: `2px solid ${theme.palette.primary.main}`,
      //   outlineOffset: '6px'
      // }
    }),
    track: ({ theme }) => ({
      color: theme.palette.primary.dark
    }),
    rail: ({ theme }) => ({
      height: theme.spacing(0.75)
    }),
    sizeSmall: ({ theme }) => ({
      '& .MuiSlider-rail': {
        height: theme.spacing(0.25)
      }
    }),
    markLabel: ({ theme }) => ({
      fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyXSmall,
      color: theme.palette.text.secondary,
      lineHeight: 1
    }),
    valueLabel: ({ theme, ownerState }) =>
      ownerState?.valueLabelDisplay === 'on'
        ? {
            backgroundColor: 'transparent',
            color: theme.palette.text.primary,
            fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
            fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
            lineHeight: capitalDesignTokens.foundations.typography.lineHeight.displaySmall
          }
        : {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyXSmall,
            lineHeight: capitalDesignTokens.foundations.typography.lineHeight.bodyXSmall,
            padding: theme.spacing(0.5, 1),
            borderRadius: capitalDesignTokens.foundations.units.unitHalf,
            borderColor: theme.palette.common.black,
            minHeight: 26
          }
  },
  variants: [
    {
      props: { disabled: true },
      style: ({ theme }) => ({
        '& .MuiSlider-rail': {
          background: theme.palette.action.disabledBackground
        },
        '& .MuiSlider-track, & .MuiSlider-thumb': {
          color: theme.palette.action.disabled
        }
      })
    }
  ]
};
